<template>
    <div id="membership-details-payment-tab"
         class="tab-contents">
        <div v-if="membership.hasInstallments"
             class="row action-btns-row membership-initial-btns-row">
            <button class="btn btn-default"
                    @click="handleChangeInstallments">
                <span class="fa-solid fa-pencil"></span>
                {{ l('MEMBERSHIP_DETAILS.CHANGE_INSTALLMENTS_BTN') }}
            </button>
        </div>

        <!-- TODO: Replace with flex -->
        <div id="membership-details-payments-summary"
             class="row">
            <div class="col-sm-4">
                <div class="alert alert-info cash-label">
                    {{ l('MEMBERSHIP_DETAILS.MEMBERSHIP_TOTAL') }}
                    <h3>{{ currencyFilter(paymentSummary.total) }}</h3>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="alert alert-success cash-label">
                    {{ l('MEMBERSHIP_DETAILS.PAYMENTS_MADE') }}
                    <h3>{{ currencyFilter(paymentSummary.paymentsMade) }}</h3>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="alert alert-danger cash-label">
                    {{ l('MEMBERSHIP_DETAILS.BALANCE') }}
                    <h3>{{ currencyFilter(paymentSummary.balance) }}</h3>
                </div>
            </div>
        </div>

        <table class="dt-table">
            <thead>
                <tr>
                    <th>{{ l('MEMBERSHIP_DETAILS.PAYMENT_DATE') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.PAYMENT_METHOD') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.AMOUNT') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.APPORTIONED') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.SERVICE') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.STATUS') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="subscriptionPayment in membership.getAllPayments()"
                    :key="subscriptionPayment.payment.ID">
                    <td>{{ dateFilter(subscriptionPayment.payment.takenAt) }}</td>
                    <td>{{ subscriptionPayment.payment.paymentMethod.name }}</td>
                    <td>{{ currencyFilter(subscriptionPayment.payment.amount) }}</td>
                    <td>{{ currencyFilter(subscriptionPayment.apportionedAmount) }}</td>
                    <td>{{ subscriptionPayment.payment.paymentChannel?.name }}</td>
                    <td>
                        <div v-if="!subscriptionPayment.payment.pending && !subscriptionPayment.payment.paid"
                             class="label label-danger">
                            {{ l('PAYMENT_STATUS.FAILED') }}
                        </div>
                        <div v-else-if="!subscriptionPayment.payment.pending && subscriptionPayment.payment.paid"
                             class="label label-success">
                            {{ l('PAYMENT_STATUS.PAID') }}
                        </div>
                        <div v-else
                             class="label label-warning">
                            {{ l('PAYMENT_STATUS.PENDING') }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { container } from '@/container';
import { currencyFilter } from '@/vue/filters/currencyFilter';
import { dateFilter } from '@/vue/filters/dateFilter';

export default {
    props: {
        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },
    },

    computed: {
        paymentSummary() {
            return this.membership.getPaymentSummary();
        },
    },

    methods: {
        currencyFilter,
        dateFilter,

        handleChangeInstallments() {
            container.membershipManagementService.changeInstallments(this.membership);
        },
    },
};
</script>
